import { ComponentProps } from "react";

const CaretDownIcon = (props: ComponentProps<"svg">) => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M3.67244 5.28125H10.0777C10.191 5.28173 10.3016 5.31579 10.3955 5.37913C10.4895 5.44247 10.5625 5.53225 10.6055 5.63712C10.6484 5.74198 10.6593 5.85721 10.6367 5.96825C10.6141 6.07929 10.5591 6.18115 10.4787 6.26094L7.28182 9.45781C7.22856 9.5115 7.16519 9.55413 7.09538 9.58321C7.02556 9.6123 6.95068 9.62727 6.87505 9.62727C6.79942 9.62727 6.72453 9.6123 6.65472 9.58321C6.5849 9.55413 6.52154 9.5115 6.46828 9.45781L3.2714 6.26094C3.19095 6.18115 3.13597 6.07929 3.1134 5.96825C3.09084 5.85721 3.10171 5.74198 3.14463 5.63712C3.18756 5.53225 3.26062 5.44247 3.35457 5.37913C3.44851 5.31579 3.55914 5.28173 3.67244 5.28125Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CaretDownIcon;
